// extracted by mini-css-extract-plugin
export default {"div":"climaNext_div__M+viM","containerNext":"climaNext_containerNext__obsPE","dia":"climaNext_dia__HSz3I","dato":"climaNext_dato__7HoLp"};